import React from "react";
import CampusListTable from "./campus-list-table";

export const CampusView = () => {
  return <div>
    <CampusListTable />
  </div>;
};
